import React, { useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { WidgetOpenState } from './types';
import { EDDY_TRAVELS_EVENT_NAME } from './eventHandlers';
export var WidgetContainer = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var widgetRef = useRef(null);
    useEffect(function () {
        var _a;
        var handleChatEvent = function (event) {
            if (typeof window.__ET_EVENT_HANDLER === 'function') {
                window.__ET_EVENT_HANDLER(event.detail);
            }
        };
        (_a = widgetRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(EDDY_TRAVELS_EVENT_NAME, 
        // eslint-disable-next-line
        handleChatEvent);
        return function () {
            var _a;
            return (_a = widgetRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(EDDY_TRAVELS_EVENT_NAME, 
            // eslint-disable-next-line
            handleChatEvent);
        };
    }, []);
    var containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        height: '100%',
        minHeight: isMobile ? 350 : 390,
        bottom: 0,
        right: 20,
        paddingBottom: 20,
        boxSizing: 'border-box',
        zIndex: 2147483647,
        pointerEvents: 'none',
        direction: 'ltr',
        color: 'black'
    };
    if (!props.visible) {
        containerStyle.width = 0;
        containerStyle.bottom = 'unset'; // squarespace fix
    }
    if (props.widgetOpenState !== WidgetOpenState.Open &&
        ((_a = props.partnerConfig.containerStyle) === null || _a === void 0 ? void 0 : _a.paddingBottom)) {
        containerStyle.paddingBottom = (_b = props.partnerConfig.containerStyle) === null || _b === void 0 ? void 0 : _b.paddingBottom;
    }
    if ((_c = props.partnerConfig.containerStyle) === null || _c === void 0 ? void 0 : _c.left) {
        containerStyle.left = (_d = props.partnerConfig.containerStyle) === null || _d === void 0 ? void 0 : _d.left;
    }
    if ((_e = props.partnerConfig.containerStyle) === null || _e === void 0 ? void 0 : _e.right) {
        containerStyle.right = (_f = props.partnerConfig.containerStyle) === null || _f === void 0 ? void 0 : _f.right;
    }
    return (React.createElement("div", { id: "__EDDY_TRAVELS_CHAT_WIDGET", style: containerStyle, ref: widgetRef, role: "application" }, props.children));
};
